import React from 'react'
import { cn } from './cn'

export interface ReceiptRow {
  /** React list key; not rendered. */
  key: string
  /** 左欄說明（i18n 在呼叫端）。 */
  label: React.ReactNode
  /** 右欄金額或數值（i18n／格式化在呼叫端）。 */
  value: React.ReactNode
  /** `discount` = 省下的金額（綠）；`total` = 合計列（粗體、加大、上方實線）。 */
  variant?: 'discount' | 'total'
  /** 掛在數值 span 上，讓呼叫端的測試可以直接選到金額。 */
  'data-testid'?: string
}

export interface ReceiptRowsProps {
  rows: ReceiptRow[]
  /** 掛在外框上（結帳面板用 `*-amount-breakdown`）。 */
  'data-testid'?: string
  className?: string
}

/**
 * 金額明細列（.checkout-breakdown ＋ .checkout-br-row）：左說明右數字、合計加重。
 * 形狀原本手寫在結帳面板裡，收成元件後由結帳與席次調整共用。
 * 樣式沿用既有語意 class（design-guideline §11.1：既有語意 class 不改寫成 utility）。
 */
export function ReceiptRows({ rows, className, ...rest }: ReceiptRowsProps) {
  return (
    <div className={cn('checkout-breakdown', className)} data-testid={rest['data-testid']}>
      {rows.map((row) => (
        <div
          key={row.key}
          className={cn(
            'checkout-br-row',
            row.variant === 'discount' && 'is-discount',
            row.variant === 'total' && 'is-total'
          )}
        >
          <span className="k">{row.label}</span>
          <span className="v" data-testid={row['data-testid']}>
            {row.value}
          </span>
        </div>
      ))}
    </div>
  )
}
